var render = function () {
  var _vm$spotCheckVideo;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sc-wrapper"
  }, [!_vm.isPlayingAnimation ? _c('intro-button', {
    staticClass: "intro-button",
    attrs: {
      "is-loading": false,
      "on-click": _vm.handleOnClick,
      "transition": "fade",
      "tabIndex": "8"
    }
  }) : _vm._e(), _c('div', {
    class: {
      'intro-container': true,
      'is-playing-animation': _vm.isPlayingAnimation
    }
  }, [!_vm.isPlayingAnimation ? _c('h1', {
    staticClass: "activity-title",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("\n      Spot Check\n    ")]) : _vm._e(), !_vm.isPlayingAnimation ? _c('h2', {
    staticClass: "activity-subtitle",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.activityTitle.display) + "\n    ")]) : _vm._e(), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isPlayingAnimation,
      expression: "!isPlayingAnimation"
    }],
    ref: "spotCheckIntroVideo",
    attrs: {
      "id": "animation-video-background",
      "playsinline": "",
      "crossorigin": "anonymous"
    }
  }, [_c('source', {
    attrs: {
      "src": (_vm$spotCheckVideo = _vm.spotCheckVideo) === null || _vm$spotCheckVideo === void 0 ? void 0 : _vm$spotCheckVideo.src
    }
  })]), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPlayingAnimation,
      expression: "isPlayingAnimation"
    }],
    ref: "spotCheckIntroVideo",
    attrs: {
      "id": "animation-video",
      "playsinline": "",
      "crossorigin": "anonymous"
    }
  }), _c('video-player-controls', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPlayingAnimation,
      expression: "isPlayingAnimation"
    }],
    attrs: {
      "video": _vm.spotCheckVideo,
      "videoReference": this.$refs.spotCheckIntroVideo
    }
  })], 1), _vm.isPlayingAnimation ? _c('portal', {
    attrs: {
      "to": "next-activity-button"
    }
  }, [_c('next-activity-button', {
    attrs: {
      "on-click": _vm.onComplete,
      "removeTabIndex": ""
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }